export const state = {
  // product: undefined,
  // products: []
  ticket: {},
  tickets: [],
  pagination: {
    size: 10,
  },
};
